// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"selection-item_shadow__HhdXe","chip":"selection-item_chip__kMhIS","selected":"selection-item_selected__1YWiJ"};